import { render, staticRenderFns } from "./RunesPage.vue?vue&type=template&id=d03d661c&"
import script from "./RunesPage.vue?vue&type=script&lang=ts&"
export * from "./RunesPage.vue?vue&type=script&lang=ts&"
import style0 from "./RunesPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports